import apiturnocaixa from '@/services/api-recebimentoweb';

let findTimeout = null;

export default {
  namespaced: true,

  state: {
    list: [],
    loading: false,
  },

  getters: {
    list: (state) => state.list,
  },

  // NUNCA ALTERAR state DIRETAMENTE EM ACTIONS
  actions: {
    async find(_, {
      where, ...params
    } = {}) {
      const [{ data }, { data: { count: total } }] = await Promise.all([
        apiturnocaixa.get('turnocaixa', { params: { ...where, ...params } }),
        apiturnocaixa.get('turnocaixa/count', { params: where }),
      ]);

      return { data, total };
    },

    async findFechados({ dispatch }, {
      where = {}, ...params
    } = {}) {
      const queryWhere = {
        'tucdataencerramento:is not null': 'is not null',
        ...where,
      };

      const res = await dispatch('find', {
        where: queryWhere,
        orderBy: 'tucdataencerramento desc',
        ...params,
      });

      return res;
    },

    async findById(_, { id }) {
      const { data } = await apiturnocaixa.get(`turnocaixa/${id}`);
      return data;
    },

    async findByTurnoId(_, { id }) {
      const { data } = await apiturnocaixa.get(`turnocaixa/id/${id}`);
      return data;
    },

    // CONSULTA COM CONTROLE DE CACHE
    async findWithCache({ commit, state }, { force, ttl } = {}) {
      if (!force && state.list?.length > 0) {
        return;
      }

      clearTimeout(findTimeout);

      const { data } = await apiturnocaixa.get('turnocaixa', {
        params: {
          orderBy: 'tucdataabertura desc',
        },
      });

      commit('SET_LIST', data);

      if (ttl === Infinity) return;

      findTimeout = setTimeout(() => {
        commit('SET_LIST', null);
      }, ttl ?? 1000 * 60); // TTL -> Time To Live
    },
  },

  // APENAS O MUTATION FAZ ALTERAÇÕES NO STATE
  mutations: {
    SET_LIST(state, list) {
      state.list = list ?? [];
    },
    loading(state, request) {
      state.loading = request ?? false;
    },
  },
};
